import _ from "lodash";

const CurriculumInsightsPolicy = {
  PlannerElementInsight: {
    fields: {
      plannerElementInsights: {
        // Define keyArgs to ensure proper cache separation based on context and filters
        // Returns a stable string key that uniquely identifies each query combination
        keyArgs: args => {
          const context = _.get(args, "context", {});
          const nestedFilters = _.get(args, "filters.filters", {});

          // Create a deterministic cache key from all distinguishing parameters
          // This ensures separate cache entries for different grades/subjects/courses
          const cacheKeyObject = {
            // Context parameters that identify the view
            plannerElementSetId: _.get(context, "plannerElementSetId"),
            elementType: _.get(context, "elementType"),
            primaryEntityId: _.get(context, "primaryEntityId"),
            viewType: _.get(context, "viewType"),
            groupByEntity: _.get(context, "groupByEntity"),
            plannerElementNodeSetId: _.get(context, "plannerElementNodeSetId"),
            // Filter parameters (excluding pagination-related fields like 'first', 'after')
            searchTerm: _.get(nestedFilters, "searchTerm"),
            includedSubjects: _.get(nestedFilters, "subjects.includeIds", []),
            excludedSubjects: _.get(nestedFilters, "subjects.excludeIds", []),
            includedDepartments: _.get(
              nestedFilters,
              "departments.includeIds",
              []
            ),
            excludedDepartments: _.get(
              nestedFilters,
              "departments.excludeIds",
              []
            ),
            includedCourses: _.get(
              nestedFilters,
              "learningCourses.includeIds",
              []
            ),
            excludedCourses: _.get(
              nestedFilters,
              "learningCourses.excludeIds",
              []
            ),
            includedGrades: _.get(nestedFilters, "grades.includeIds", []),
            excludedGrades: _.get(nestedFilters, "grades.excludeIds", []),
          };

          const cacheKey = JSON.stringify(cacheKeyObject);
          return cacheKey;
        },
      },
    },
  },
  // Disable normalization for certain fields to prevent cache collisions
  // since two grade/subject/course may have same element node but different insight stats under same id
  PlannerElementNodeInsight: {
    keyFields: () => false,
  },
  PlannerElementInsightEdge: {
    keyFields: () => false,
  },
  InsightStats: {
    keyFields: () => false,
  },
  AssignmentInsightStats: {
    keyFields: () => false,
  },
  PlanningATLInsight: {
    keyFields: () => false,
  },
  PlanningLPAInsight: {
    keyFields: () => false,
  },
  PlanningConceptInsight: {
    keyFields: () => false,
  },
  ThemeDescriptorInsightV2: {
    keyFields: () => false,
  },
  PlanningSubjectInsight: {
    keyFields: () => false,
  },
  CurriculumPOIInsightsEdge: {
    keyFields: () => false,
  },
  CurriculumPOIInsightsConnection: {
    keyFields: () => false,
  },
};

export default CurriculumInsightsPolicy;
